import type { Event } from '../types';

export const ABTestEventData = {
  ABTestGasBuddy: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestGasBuddy',
  } as Event<'ABTestGasBuddy'>,
  ABTestEducation: {
    eventAction: 'ABTest',
    eventLabel: 'EducationTest',
  } as Event<'EducationTest'>,
  ABTestLoanQuestion: {
    eventAction: 'ABTest',
    eventLabel: 'LoanQuestionTest',
  } as Event<'LoanQuestionTest'>,
  ABTestSkipLN: {
    eventAction: 'ABTest',
    eventLabel: 'SkipLNTestV2',
  } as Event<'SkipLNTestV2'>,
  ABTestRefiOnboardingConfirmation: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestRefiOnboardingConfirmation',
  } as Event<'ABTestRefiOnboardingConfirmation'>,
  ABTestEnableRefiCreditPullOnAppUsed: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestEnableRefiCreditPullOnAppUsed',
  } as Event<'ABTestEnableRefiCreditPullOnAppUsed'>,
  ABTestRefiOnboardingQuestion2: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestRefiOnboardingQuestion2',
  } as Event<'ABTestRefiOnboardingQuestion2'>,
  ABTestShopforSEO: {
    eventAction: 'ABTest',
    eventLabel: 'ShopforSEO',
  } as Event<'ShopforSEO'>,
  ABTestEnableFastDobLoading: {
    eventAction: 'ABTest',
    eventLabel: 'FastDobLoading',
  } as Event<'FastDobLoading'>,
  ABTestShowInsuredHistory: {
    eventAction: 'ABTest',
    eventLabel: 'ShowInsuredHistory',
  } as Event<'ShowInsuredHistory'>,
  ABTestCreditRangeV1: {
    eventAction: 'ABTest',
    eventLabel: 'CreditRangeV1',
  } as Event<'CreditRangeV1'>,
  ABTestCarUsageBusiness: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestCarUsageBusiness',
  } as Event<'ABTestCarUsageBusiness'>,
  ABTestConfirmDob: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestConfirmDob',
  } as Event<'ABTestConfirmDob'>,
  ABTestWebSignupGarageDwep: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestWebSignupGarageDwep',
  } as Event<'ABTestWebSignupGarageDwep'>,
  ABTestAskVehicleOwnership: {
    eventAction: 'ABTest',
    eventLabel: 'askVehicleOwnership',
  } as Event<'askVehicleOwnership'>,
  ABTestStashInterstitial: {
    eventAction: 'ABTest',
    eventLabel: 'stashInterstital',
  } as Event<'stashInterstital'>,
  HOME_OWNER_SHIP_PROMPT: {
    eventAction: 'ABTest',
    eventLabel: 'HOME_OWNER_SHIP_PROMPT',
  } as Event<'HOME_OWNER_SHIP_PROMPT'>,
  TELEMATICS_SIGNUP_INTRO: {
    eventAction: 'ABTest',
    eventLabel: 'TELEMATICS_SIGNUP_INTRO',
  } as Event<'TELEMATICS_SIGNUP_INTRO'>,
  ABTestPartnerWelcomeRedesignV3: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestPartnerWelcomeRedesignV3',
  } as Event<'ABTestPartnerWelcomeRedesignV3'>,
  ABTestWebSignupAddCarByPlateVin: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestWebSignupAddCarByPlateVin',
  } as Event<'ABTestWebSignupAddCarByPlateVin'>,
  ABTestOriginationFee: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestOriginationFee',
  } as Event<'ABTestOriginationFee'>,
  ABTestAskFullCoverageV2: {
    eventAction: 'ABTest',
    eventLabel: 'ask_full_coverage_v2',
  } as Event<'ask_full_coverage_v2'>,
  ABTestSignupRefiCrossSellCopyV2: {
    eventAction: 'ABTest',
    eventLabel: 'refi_cross_sell_copy_v2',
  } as Event<'refi_cross_sell_copy_v2'>,
  ABTestWaitForQuotingFinish: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestWaitForQuotingFinish',
  } as Event<'ABTestWaitForQuotingFinish'>,
  ABTestAskFullV3: {
    eventAction: 'ABTest',
    eventLabel: 'ask_full_coverage_v3',
  } as Event<'ask_full_coverage_v3'>,
  ABTestCarRecallFinish: {
    eventAction: 'ABTest',
    eventLabel: 'car_recall_finish',
  } as Event<'car_recall_finish'>,
  ABTestCarValueAdvanceDownload: {
    eventAction: 'ABTest',
    eventLabel: 'car_value_advance_download',
  } as Event<'car_value_advance_download'>,
  ABTestDriverName: {
    eventAction: 'ABTest',
    eventLabel: 'driver_name_variation',
  } as Event<'driver_name_variation'>,
  ABTestAddCarByVin: {
    eventAction: 'ABTest',
    eventLabel: 'signup_add_car_by_vin',
  } as Event<'signup_add_car_by_vin'>,
  ABTestTestimonialV2: {
    eventAction: 'ABTest',
    eventLabel: 'ABTestTestimonialV2',
  } as Event<'ABTestTestimonialV2'>,
  ABTestFuzzyMatching: {
    eventAction: 'ABTest',
    eventLabel: 'web_signup_fuzzy_matching',
  } as Event<'web_signup_fuzzy_matching'>,
  ABTestExistingUserWebapp: {
    eventAction: 'ABTest',
    eventLabel: 'signup_existing_user_webapp_2',
  } as Event<'signup_existing_user_webapp_2'>,
  ABTestExistingUserWebappMobile: {
    eventAction: 'ABTest',
    eventLabel: 'signup_existing_user_webapp_mobile_2',
  } as Event<'signup_existing_user_webapp_mobile_2'>,
  ABTestRedirectWebAppLoggedIn: {
    eventAction: 'ABTest',
    eventLabel: 'signup_redirect_web_app_logged_in',
  } as Event<'signup_redirect_web_app_logged_in'>,
  ABTestWebappNewUserOnboarding: {
    eventAction: 'ABTest',
    eventLabel: 'webapp_new_user_onboarding_2',
  } as Event<'webapp_new_user_onboarding_2'>,
  ABTestWebappNewUserOnboardingLte50: {
    eventAction: 'ABTest',
    eventLabel: 'webapp_new_user_onboarding_lte50_2',
  } as Event<'webapp_new_user_onboarding_lte50_2'>,
  ABTestSkipCarTrim: {
    eventAction: 'ABTest',
    eventLabel: 'skip_car_trim',
  } as Event<'skip_car_trim'>,
  ABTestNamePhone: {
    eventAction: 'ABTest',
    eventLabel: 'signup_name_phone',
  } as Event<'signup_name_phone'>,
  ABTestPhoneWhyJerry: {
    eventAction: 'ABTest',
    eventLabel: 'signup_phone_why_jerry',
  } as Event<'signup_phone_why_jerry'>,
  ABTestSignupAddSpouse: {
    eventAction: 'ABTest',
    eventLabel: 'signup_add_spouse',
  } as Event<'signup_add_spouse'>,
  ABTestSignupFinishV3: {
    eventAction: 'ABTest',
    eventLabel: 'signup_finish_v3',
  } as Event<'signup_finish_v3'>,
  ABTestSignupHomeQuotingCA: {
    eventAction: 'ABTest',
    eventLabel: 'signup_home_quoting_ca',
  } as Event<'signup_home_quoting_ca'>,
  ABTestMercuryQuestion: {
    eventAction: 'ABTest',
    eventLabel: 'new_mercury_question',
  } as Event<'new_mercury_question'>,
  ABTestAskCoverageV4: {
    eventAction: 'ABTest',
    eventLabel: 'ask_coverage_v4',
  } as Event<'ask_coverage_v4'>,
  ABTestAskCoverageCopy: {
    eventAction: 'ABTest',
    eventLabel: 'ask_coverage_copy',
  } as Event<'ask_coverage_copy'>,
  ABTestAskCoverageV4Session: {
    eventAction: 'ABTest',
    eventLabel: 'ask_coverage_v4_session',
  } as Event<'ask_coverage_v4_session'>,
  ABTestRenterPromptEnabled: {
    eventAction: 'ABTest',
    eventLabel: 'web_renter_prompt',
  } as Event<'web_renter_prompt'>,
  ABTestHomePromptEnabled: {
    eventAction: 'ABTest',
    eventLabel: 'web_home_prompt',
  } as Event<'web_home_prompt'>,
  ABTestMultipleCarsTipsEnabled: {
    eventAction: 'ABTest',
    eventLabel: 'multiple_cars_tips',
  } as Event<'multiple_cars_tips'>,
  ABTestCarValueCombineNameAndPhone: {
    eventAction: 'ABTest',
    eventLabel: 'car_value_combine_name_phone',
  } as Event<'car_value_combine_name_phone'>,
  ABTestCarRecallNamePageMutipleSubtitle: {
    eventAction: 'ABTest',
    eventLabel: 'car_recall_name_page_subtitle_funnel',
  } as Event<'car_recall_name_page_subtitle_funnel'>,
  ABTestCarRecallFinishPageShowRecalls: {
    eventAction: 'ABTest',
    eventLabel: 'car_recall_finish_show_recalls',
  } as Event<'car_recall_finish_show_recalls'>,
  ABTestDisplayCarrierLogoOnFinish: {
    eventAction: 'ABTest',
    eventLabel: 'display_carrier_logo_on_finish',
  } as Event<'display_carrier_logo_on_finish'>,
};
